import { render, staticRenderFns } from "./VipManage.vue?vue&type=template&id=444e98c0&"
import script from "./VipManage.vue?vue&type=script&lang=js&"
export * from "./VipManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports